module.exports = __webpack_public_path__ + "static/media/linkedin-logo.f741d902.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/linkedin-logo.svg
// module id = 369
// module chunks = 0